import { render, staticRenderFns } from "./kine-section-fields.vue?vue&type=template&id=877831e4&scoped=true"
import script from "./kine-section-fields.vue?vue&type=script&lang=js"
export * from "./kine-section-fields.vue?vue&type=script&lang=js"
import style0 from "./kine-section-fields.vue?vue&type=style&index=0&id=877831e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877831e4",
  null
  
)

export default component.exports